import axios from "axios";
import { uri } from "../constants";

export const createReports = async (url, user_id) => {
    try {
      const response = await axios.post(`${uri}/reports`, {"url": url, "user_id": user_id});
      console.log(response, "response");
      if (response.status !== 202) {
        throw new Error('Failed to create report');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
export const getReports = async () => {
    try { 
        const response = await fetch(`${uri}/reports`);
        if (!response.ok) throw new Error("Failed to get reports");
        return await response.json();
    } catch(ex) {
      throw ex;
    }
}
export const getReportsOverview = async (month_year) => {
    try {
        const response = await fetch(`${uri}/reports/${month_year}`);
        
        return await response.json();
    } catch(ex) {
      throw ex;
    }
}
export const getUserReportOverview = async (userId) => {
  try {
      const response = await fetch(`${uri}/reports/users/${userId}`);
     
      const res =await response.json();
      console.log("res", res);
      return res;
  } catch(ex) {
    throw ex;
  }
}
export const deleteReport = async (monthYear) => {
    try {
        const response = await fetch(`${uri}/reports/${monthYear}`, {
            method: 'DELETE'
        });
        return await response.json();
    } catch(ex) {
      throw ex;
    }
}

// New function to get report jobs for a user
export const getReportJobs = async (userId) => {
  try {
    const response = await fetch(`${uri}/reports/jobs/user/${userId}`);
    if (!response.ok) {
      throw new Error(`Failed to get report jobs: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
}
export const getDailyTrends = async (userId) => {
  try {
    const response = await fetch(`${uri}/stats/daily_trends/${userId}`);
    return await response.json();
  } catch (error) {
    throw error;
  }
}

export const getReleaseStats = async (userId, year, month) => {
  try {
    const response = await fetch(`${uri}/release_stats/user/${userId}/${year}/${month}`);
    if (!response.ok) {
      throw new Error(`Failed to get release stats: ${response.statusText}`);
    }
    const data = await response.json();
    if (!data.success) {
      throw new Error(`API returned error: ${data.message || 'Unknown error'}`);
    }
    return data.data;
  } catch (error) {
    console.error("Error fetching release stats:", error);
    throw error;
  }
}